import {
  SET_DISPLAY_CONTENT,
  GET_ACTIVE_STORES,
  GET_STORES,
  FILTER_STORES,
  CLEAR_FILTERED_STORES,
  SEARCH_STORES,
  SELECTED_STORE,
  FORM_DATA,
  FORM_ERROR,
  STORE_ERROR,
} from "../types";

const StoreReducer = (state, action) => {
  switch (action.type) {
    case SET_DISPLAY_CONTENT:
      return { ...state, display_content: action.payload };

    case GET_ACTIVE_STORES:
      return { ...state, activeStores: action.payload };

    case GET_STORES:
      return { ...state, stores: action.payload };

    case FILTER_STORES:
      return {
        ...state,
        stores_filtered: state.stores.filter((store) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return store.store_name.match(regex);
        }),
      };

    case CLEAR_FILTERED_STORES:
      return { ...state, stores_filtered: null };

    case SEARCH_STORES:
      return { ...state, stores_searched: action.payload };

    case SELECTED_STORE:
      return { ...state, selected_store: action.payload };

    case FORM_DATA:
      return { ...state, form_data: action.payload };

    case FORM_ERROR:
      return { ...state, form_error: action.payload };

    case STORE_ERROR:
      return { ...state, store_error: action.payload };

    default:
      return state;
  }
};

export default StoreReducer;